import React from 'react';
import classNames from 'classnames';

import css from './styles.css';

const SuperHost = ({ rootClassName = {} }) => (
  <div className={classNames(css.superHostContainer, rootClassName)}>
    SUPERHOST
  </div>
);

export default SuperHost;



// WEBPACK FOOTER //
// ./src/components/SuperHost/index.js